module.exports = __webpack_public_path__ + "static/media/VALUE PLUS.9a3bd0cd.svg";